import { FC, PropsWithChildren, useRef } from 'react';

import { usePage } from '@inertiajs/react';

import { Footer } from '../components/Footer';
import Header, { HeaderRef } from '../components/Header';
import { MobileBottomNav } from '../components/MobileBottomNav';
import { SeoHead } from '../components/shared/SeoHead';
import { CartProvider } from '../context/cart-context';
import { CurrentUser } from '../types';
import { Metadata, StructuredData } from '../types/shared';

type PageProps = {
    metadata: Metadata;
    structuredData?: StructuredData | null;
    currentUser: CurrentUser | null;
    newNotificationPresent: boolean;
};

const Layout: FC<PropsWithChildren> = ({ children }) => {
    const { metadata, structuredData, currentUser, newNotificationPresent } =
        usePage<PageProps>().props;
    const headerRef = useRef<HeaderRef>(null);

    return (
        <CartProvider>
            <SeoHead metadata={metadata} structuredData={structuredData} />

            <div className="flex min-h-screen flex-col">
                <Header ref={headerRef} />

                <main className="flex-1">{children}</main>

                <Footer />

                <MobileBottomNav
                    currentUser={currentUser}
                    onSearchClick={() => headerRef.current?.focusSearch()}
                    newNotificationPresent={newNotificationPresent}
                />
            </div>
        </CartProvider>
    );
};

export default Layout;
